// No mock APIs are registered. The Fuse mock-api interceptor passes all
// requests through to the real backend when this list is empty.
export const mockApiServices = [];
